var _style, _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscount2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 128 128",
    style: {
      enableBackground: "new 0 0 128 128"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F44336;}\n\t.st1{enable-background:new    ;}\n\t.st2{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.7,60.6l56-56C63.9,1.5,68,0,72.1,0s8.2,1.6,11.3,4.7l40,40c6.3,6.2,6.3,16.4,0,22.6l-56,56 c-3.1,3.1-7.2,4.7-11.3,4.7h-48c-2.1,0-4.2-0.8-5.7-2.3c-1.3-1.3-2.3-3-2.3-4.8V73.3C0.1,68.7,1.3,64.1,4.7,60.6z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M43.5,68.7l-5.8-5.8l65.4-21.5l5.7,5.7L43.5,68.7z M61.1,21.1c3.7-3.7,7.2-5.6,10.6-5.8 c3.4-0.2,6.5,1.1,9.3,3.9c2.9,2.9,4.2,6,4.1,9.4c-0.2,3.4-2.1,6.9-5.8,10.6c-3.7,3.7-7.2,5.6-10.6,5.8c-3.4,0.2-6.5-1.1-9.3-3.9 c-2.9-2.9-4.2-6-4.1-9.4C55.4,28.4,57.4,24.8,61.1,21.1z M67.1,70.7c3.7-3.7,7.2-5.6,10.6-5.8s6.5,1.2,9.3,4c2.8,2.8,4.2,5.9,4,9.3 c-0.2,3.4-2.1,6.9-5.8,10.6c-3.7,3.7-7.3,5.6-10.7,5.8c-3.4,0.2-6.5-1.1-9.3-3.9c-2.9-2.9-4.2-6-4.1-9.4 C61.4,77.9,63.4,74.4,67.1,70.7z M67.3,27.2c-2.7,2.7-4.2,4.8-4.5,6.3c-0.2,1.1,0.1,2.1,0.9,3c0.8,0.8,1.8,1.2,3,1 c1.5-0.3,3.6-1.8,6.3-4.5c2.7-2.7,4.2-4.8,4.5-6.3c0.2-1.2-0.1-2.2-0.9-3c-0.8-0.8-1.8-1.1-3-0.9C72.1,23,70,24.5,67.3,27.2z  M73.3,76.8c-2.7,2.7-4.2,4.8-4.4,6.3c-0.2,1.2,0.1,2.2,0.9,3c0.8,0.8,1.8,1.2,3,0.9c1.5-0.3,3.6-1.8,6.3-4.5s4.2-4.8,4.5-6.3 c0.2-1.1-0.1-2.1-1-3c-0.8-0.8-1.8-1.2-2.9-0.9C78.1,72.6,76,74.1,73.3,76.8z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M27.1,83.8c10.4,0,18.8,8.4,18.8,18.8s-8.4,18.8-18.8,18.8S8.2,113,8.2,102.6S16.7,83.8,27.1,83.8z M17.6,102.6 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscount2);
export default __webpack_public_path__ + "static/media/Discount2.ed08c15ded9cf175fe18a21ef18d264e.svg";
export { ForwardRef as ReactComponent };